import { Box, Button, Modal, Typography, useMediaQuery } from '@mui/material'
import React from 'react'

function AddNewModal({
  open,
  handleClose,
  onSubmit,
  dialogTitle,
  disabled,
  children,
  cancelButton = false,
}) {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'))

  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="modal-title">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: (theme) => theme.palette.white.main,
          borderRadius: 2,
          boxShadow: 24,
          p: isMobile ? 2 : 4,
          width: isMobile ? '95vw' : '55vw',
        }}
      >
        <Typography variant="h2" color="primary" id="modal-title" sx={{ pb: 3 }}>
          {dialogTitle}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            px: 1.5,
            overflowY: 'auto',
            maxHeight: '65vh',
          }}
        >
          {children}
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, pt: 4 }}>
          {cancelButton && <Button onClick={handleClose}>Cancel</Button>}
          <Button variant="contained" onClick={onSubmit} disabled={disabled}>
            Save & Close
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default AddNewModal
